import { render, staticRenderFns } from "./station-detail-setting.vue?vue&type=template&id=3e8b76f2&scoped=true&"
import script from "./station-detail-setting.vue?vue&type=script&lang=js&"
export * from "./station-detail-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b76f2",
  null
  
)

export default component.exports